export function CmsBrand({ inverted = false, className = "", width }: { inverted?: boolean; className?: string; width?: number }) {
  return (
    <img
      className={`cms-brand-logo ${className}`.trim()}
      src={inverted ? "/sculpto-cms-inverted.svg" : "/sculpto-cms.svg"}
      width={width ?? 229}
      style={width ? { width, maxWidth: "100%", height: "auto" } : undefined}
      height={60}
      alt="Sculpto CMS"
    />
  );
}
